import { StencilRouteTransitionLoadingLayout } from './stencil-route-transition-loading.style';

interface StencilRouteTransitionLoadingProps extends React.PropsWithChildren {
    active: boolean;
    backgroundColor: string;
    delayMs: number;
    leftOffset?: string;
    onVisible: VoidFunction;
    topOffset?: string;
}

export const StencilRouteTransitionLoading: React.FC<StencilRouteTransitionLoadingProps> = ({
    active,
    backgroundColor,
    children,
    delayMs,
    leftOffset = '0',
    onVisible,
    topOffset = '0',
}) => (
    <StencilRouteTransitionLoadingLayout
        active={active}
        backgroundColor={backgroundColor}
        delayMs={delayMs}
        leftOffset={leftOffset}
        topOffset={topOffset}
        aria-hidden={!active}
        data-testid="stencil-route-transition-overlay"
        onAnimationStart={onVisible}
    >
        {children}
    </StencilRouteTransitionLoadingLayout>
);
